import RedditPixel from './RedditPixel';

export default RedditPixel;
